/* eslint-disable no-unused-vars */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Typography } from '@material-ui/core'
import AssessmentIcon from '@material-ui/icons/Assessment'

export enum Colors {
  default = 'green',
  green = 'green',
  red = 'red',
  blue = 'blue',
  grey = 'grey'
}

type Props = {
  title: string
  number: number | string
  color?: Colors
}

type StyledProps = {
  color?: Colors
}

const useStyles = makeStyles({
  root: {
    position: 'relative',
    height: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    fontSize: '12pt',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: '#4B4B4B',
    fontWeight: 400
  },
  number: {
    fontSize: '40pt',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: 700,
    textAlign: 'center',

    color: (props: StyledProps) => {
      const { color } = props
      switch (color) {
        case Colors.blue:
          return '#2D4054'
          break
        case Colors.red:
          return '#EF6167'
          break
        case Colors.grey:
          return '#787878'
          break
        case Colors.green:
          return '#06BAB2'
          break
        default:
          return '#2D4054'
          break
      }
    }
  }
})

export default function CardWidget ({ title, number, color = Colors.blue }: Props): JSX.Element {
  const classes = useStyles({ color })

  return (
    <Card className={classes.root}>
      <CardContent>
        <div className={classes.header}>
          <Typography className={classes.title} gutterBottom>{title}</Typography>
          <AssessmentIcon style={{ color: '#636363' }} />
        </div>
        <Typography className={`${classes.number}`}>{number}</Typography>
      </CardContent>
    </Card>
  )
}
